var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.71676 0.199951H3.91675C2.15842 0.199951 0.725098 1.63329 0.725098 3.39162V5.11662C0.725098 5.45829 1.00843 5.74162 1.3501 5.74162C1.69176 5.74162 1.9751 5.45829 1.9751 5.11662V3.39162C1.9751 2.31662 2.85009 1.44995 3.91675 1.44995H5.71676C6.05842 1.44995 6.34176 1.16662 6.34176 0.824951C6.34176 0.483285 6.06676 0.199951 5.71676 0.199951Z",
    fill: "#7066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.0749 0.199951H12.2749C11.9332 0.199951 11.6499 0.483285 11.6499 0.824951C11.6499 1.16662 11.9332 1.44995 12.2749 1.44995H14.0749C15.1499 1.44995 16.0166 2.32495 16.0166 3.39162V5.11662C16.0166 5.45829 16.2999 5.74162 16.6416 5.74162C16.9833 5.74162 17.2666 5.45829 17.2666 5.11662V3.39162C17.2749 1.63329 15.8416 0.199951 14.0749 0.199951Z",
    fill: "#7066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.71676 15.55H3.91675C2.84175 15.55 1.9751 14.675 1.9751 13.6083V11.8833C1.9751 11.5416 1.69176 11.2583 1.3501 11.2583C1.00843 11.2583 0.725098 11.5416 0.725098 11.8833V13.6083C0.725098 15.3666 2.15842 16.8 3.91675 16.8H5.71676C6.05842 16.8 6.34176 16.525 6.34176 16.175C6.34176 15.8333 6.06676 15.55 5.71676 15.55Z",
    fill: "#7066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.6499 11.2583C16.3082 11.2583 16.0249 11.5416 16.0249 11.8833V13.6083C16.0249 14.6833 15.1499 15.55 14.0832 15.55H12.2832C11.9415 15.55 11.6582 15.8333 11.6582 16.175C11.6582 16.5166 11.9415 16.8 12.2832 16.8H14.0832C15.8415 16.8 17.2749 15.3666 17.2749 13.6083V11.8833C17.2749 11.5333 16.9915 11.2583 16.6499 11.2583Z",
    fill: "#7066FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.89183 8.07491C10.3668 8.07491 11.5752 6.87491 11.5752 5.39158C11.5752 3.90825 10.3752 2.70825 8.89183 2.70825C7.4085 2.70825 6.2085 3.90825 6.2085 5.39158C6.2085 6.87491 7.41683 8.07491 8.89183 8.07491Z",
    fill: "#7066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.9083 8.8833H7.21667C5.50834 8.8833 4.125 10.275 4.125 11.975V12.3166C4.125 13.1166 4.78333 13.775 5.58333 13.775H12.55C13.35 13.775 14.0083 13.1166 14.0083 12.3166V11.975C14 10.2666 12.6167 8.8833 10.9083 8.8833Z",
    fill: "#7066FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestActive);
export default __webpack_public_path__ + "static/media/request_active.8692ff520bb1da45487a21506c8ca223.svg";
export { ForwardRef as ReactComponent };